import { datePresetRange } from 'library/helpers/accessLogHelpers';
import { accessLogsActions } from './slice';

/**
 * THE action that refreshes the access-log feed, as data rather than as a dispatch.
 *
 * It exists so the Refresh button, the pull-down gesture and a mutation that PRODUCES a log row (a
 * remote unlock) all mean the same thing by "refresh". The two rules it carries were previously only
 * inside `useAccessLogRefresh`, which a saga cannot call — so a saga refreshing the feed would have had
 * to re-derive them and drift:
 *
 * 🛑 A RELATIVE PRESET IS RECOMPUTED FIRST. The window is stored as fixed ISO strings, so a tab left
 * open overnight has `today` pinned to yesterday — and a refresh that re-sent it would return the same
 * rows forever while insisting it had just fetched them. `custom` is left alone: a range the user picked
 * by hand is not ours to re-base.
 *
 * ⚠️ THE PAGE IS KEPT. Refresh means "this view, now", not "jump to the newest" — sending the reader
 * back to page 1 from page 4 loses their place for no reason they asked for. Passing `page` explicitly
 * is also what stops setAccessLogsFilters' own reset-to-1 from firing.
 *
 * @param {object} p
 * @param {number} p.orgID
 * @param {object} [p.filters] - the org's current `AccessLogs.filters` entry.
 * @returns {object} a redux action to dispatch.
 */
export const accessLogRefreshAction = ({ orgID, filters }) => {
	const range = datePresetRange(filters?.datePreset);

	// A custom range (or none at all) re-fetches exactly what is on screen.
	if (!range) return accessLogsActions.loadAccessLogs();

	return accessLogsActions.setAccessLogsFilters({
		orgID,
		filters: { ...range, page: filters?.page || 1 },
		resetPage: false
	});
};
